import { render, staticRenderFns } from "./modal-trunks-add-ip-form.vue?vue&type=template&id=7094188e&"
import script from "./modal-trunks-add-ip-form.vue?vue&type=script&lang=js&"
export * from "./modal-trunks-add-ip-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports